import './LoginForm.css';
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useSetRecoilState } from 'recoil';
import { navigationBarState } from '../../../states/NavigationBar';
import { accessTokenState } from '../../../states/Token'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import QrCodeIcon from '@mui/icons-material/QrCode';

function LoginForm() {
    const navigate = useNavigate();
    const setAccessToken = useSetRecoilState(accessTokenState);
    const [id, setID] = useState("")
    const [password, setPassword] = useState("")
    const passwordInputRef = useRef(null)
    const [siteSettings, setSiteSettings] = useState({
        signup_enabled: true,
        find_account_enabled: true
    });

    const setNavigationBarState = useSetRecoilState(navigationBarState);

    useEffect(() => {
        setNavigationBarState(null);

        // Fetch site settings for feature toggles
        axios.get('/users/settings/').then(response => {
            setSiteSettings(response.data);
        }).catch(error => {
            // On error, keep default settings (features enabled)
            console.error('Failed to fetch site settings:', error);
        });
    }, []);

    function login(id, password) {
        if (id == "") {
            toast.error("ID를 입력하세요.", { id: 'login' })
            return
        } else if (password == "") {
            toast.error("Password를 입력하세요.", { id: 'login' })
            return
        }
        toast.loading("로그인중...", { id: 'login' })
        const data = new FormData();
        data.append('username', id);
        data.append('password', password);
        axios.post('/users/login/', data).then(response => {
            // @@ 심사대응
            // let user = response.data.user
            // if (user.type == "S" && window.navigator.userAgent.indexOf("kutest_App") == -1) {
            //     axios.post('/users/logout/', null).then(response => {
            //         toast.error("응시자 계정은 '통번역자격시험' 모바일 앱을 통해\n로그인이 가능합니다.", { id: 'login' })
            //     }).catch(error => {
            //         toast.error("응시자 계정은 '통번역자격시험' 모바일 앱을 통해\n로그인이 가능합니다.", { id: 'login' })
            //     });
            // } else {
                let user = response.data.user
                toast.success(user.nickname + "님 환영합니다.", { id: 'login' })
                setAccessToken(response.data)
            // }
        }).catch(error => {
            if (error.response.status == 401) {
                toast.error(error.response.data.detail, { id: 'login' })
                setPassword("")
                passwordInputRef.current.focus()
            } else {
                toast.error("일시적인 오류로 로그인할 수 없습니다.", { id: 'login' })
            }
        });
    }

    const onLogin = () => {
        login(id, password)
    }

    function onChangeID({target: {value}}) {
        setID(value)
    }

    function onKeyDownID(event) {
        if (event.key == 'Enter') {
            passwordInputRef.current.focus()
        }
    }

    function onChangePassword({target: {value}}) {
        setPassword(value)
    }

    function onKeyDownPassword(event) {
        if (event.key == 'Enter') {
            onLogin()
        }
    }

    function onSignupClick() {
        navigate("/signup")
    }

    function onFindAccountClick() {
        navigate("/find-account")
    }

    function onPrivatePolicyClick() {
        navigate("/privacy-policy")
    }

    function onQRLoginClick() {
        window.qrLoggedIn = function(id, password) {
            login(id, password)
        }
        if (window.KUTAppInterface) {
            window.KUTAppInterface.qrLogin();
        } else if (window.webkit && window.webkit.messageHandlers.KUTAppInterface) {
            window.webkit.messageHandlers.KUTAppInterface.postMessage("qrLogin");
        }
    }

    const isApp = window.navigator.userAgent.indexOf("kutest_App") !== -1;

    return <div className="login-page">
        <div className="login-container">
            <div className="login-header">
                <img className="login-logo" src={`${process.env.PUBLIC_URL}/logo.png`} alt='' />
                <div className="login-title">통번역 자격시험</div>
                <div className="login-subtitle">Interpretation & Translation Evaluation Test</div>
            </div>

            <div className="login-form">
                <div className="login-input-group">
                    <input
                        className="login-input"
                        type="text"
                        placeholder="아이디"
                        value={id}
                        onKeyDown={onKeyDownID}
                        onChange={onChangeID}
                    />
                    <input
                        ref={passwordInputRef}
                        className="login-input"
                        type="password"
                        placeholder="비밀번호"
                        value={password}
                        onKeyDown={onKeyDownPassword}
                        onChange={onChangePassword}
                    />
                </div>

                {siteSettings.find_account_enabled && (
                    <div className="login-find-account" onClick={onFindAccountClick}>
                        아이디·비밀번호 찾기
                    </div>
                )}

                <button className="login-button" onClick={onLogin}>로그인</button>
                {isApp && (
                    <button className="login-qr-button" onClick={onQRLoginClick}>
                        <QrCodeIcon />
                        <span>QR 로그인</span>
                    </button>
                )}

                {siteSettings.signup_enabled && (
                    <div className="login-signup-section">
                        <span className="login-signup-text">아직 회원이 아니신가요?</span>
                        <span className="login-signup-link" onClick={onSignupClick}>회원가입</span>
                    </div>
                )}

                <div className="login-footer">
                    <span className="login-privacy-link" onClick={onPrivatePolicyClick}>개인정보처리방침</span>
                </div>
            </div>
        </div>
    </div>
}

export default LoginForm;